
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  data: () => ({
    title: "Comment installer le pixel Meta sur son site internet | ALEO",
    description:
      "Apprenez à installer le pixel Meta sur votre site WordPress, Shopify ou PrestaShop. Guide complet par ALEO, agence partenaire Meta Ads installation, test et conformité RGPD inclus.",
  }),

  head() {
    return {
      title: this.title,
      meta: [
        {
          hid: "description",
          name: "description",
          content: this.description,
        },
        {
          hid: "og:title",
          property: "og:title",
          content: this.title,
        },
        {
          hid: "og:description",
          property: "og:description",
          content: this.description,
        },
      ],
    };
  },
};
